import { EColors } from "@atoms/ZColors/interface";
import ZIcon from "@atoms/ZIcon";
import { EIcons } from "@atoms/ZIcon/interface";
import ZTooltip from "@atoms/ZTooltip";
import { ZWonTag, ZLostTag } from "@atoms/ZTerminalStageTag";
import ZTypography from "@atoms/ZTypography";
import { EFontWeights } from "@atoms/ZTypography/interface";
import { Col, Divider, Row } from "antd";
import React, { FC, memo } from "react";
import flatten from "lodash/flatten";
import { IKanbanHeaderBox } from "./interface";
import "./index.less";

const { ZText } = ZTypography;

const ZKanbanHeaderBox: FC<IKanbanHeaderBox> = ({
	allowAddOpportunity,
	estimatedValue,
	count,
	index,
	addOpportunity,
	stageName,
	isWonStage,
	isLostStage,
	stagesLength
}) => {
	const headerColorArray = [
		`${EColors.BLUE}-2`,
		`${EColors.RED}-2`,
		`${EColors.VOLCANO}-2`,
		`${EColors.ORANGE}-2`,
		`${EColors.GOLD}-3`,
		`${EColors.LIME}-3`,
		`${EColors.GREEN}-3`,
		`${EColors.CYAN}-3`,
		`${EColors.GOLD}-3`,
		`${EColors.PURPLE}-2`,
		`${EColors.MAGENTA}-2`
	];
	const colorArrayLength = headerColorArray.length;
	const repeat = stagesLength
		? Math.ceil(stagesLength / colorArrayLength)
		: colorArrayLength;
	const repeatHeaderColorArray = flatten(
		new Array(repeat).fill(headerColorArray)
	);

	const color = isWonStage
		? "green-3"
		: isLostStage
		? "red-2"
		: repeatHeaderColorArray[index];

	return (
		<div
			className={`z-header-box bg-gray-2 sticky top-0 border-solid border-${color} z-10`}
		>
			<div className="p-3">
				<div className="flex items-center justify-between w-full">
					<div className="flex items-center w-11/12">
						<ZText
							level={0}
							weight={EFontWeights.MEDIUM}
							className="mr-2 px-2 py-1 rounded-full bg-gray-4"
						>
							{count}
						</ZText>
						<div className="w-10/12 flex items-center">
							<ZText
								weight={EFontWeights.MEDIUM}
								className="overflow-hidden whitespace-nowrap overflow-ellipsis"
							>
								{stageName}
							</ZText>
							{isWonStage && <ZWonTag />}
							{isLostStage && <ZLostTag />}
						</div>
					</div>
					{allowAddOpportunity && (
						<ZTooltip title="Add opportunity" placement="bottom">
							<div
								className="add-icon cursor-pointer mb-1"
								onClick={addOpportunity}
							>
								<ZIcon name={EIcons.ADD} size="sm" />
							</div>
						</ZTooltip>
					)}
				</div>
				<Row className="mt-2 w-full items-center content-start">
					<Col span={8}>
						<ZText colorVariant={6}>Estm. Value</ZText>
					</Col>
					<Col span={16} className="inline-flex">
						<ZTooltip
							title={estimatedValue}
							placement="bottom"
							showtooltip={estimatedValue.length >= 23}
						>
							<ZText
								level={1}
								color={EColors.CYAN}
								colorVariant={7}
								className="overflow-hidden overflow-ellipsis whitespace-nowrap"
							>
								{estimatedValue}
							</ZText>
						</ZTooltip>
					</Col>
				</Row>
			</div>
			<Divider />
		</div>
	);
};

export default memo(ZKanbanHeaderBox);
